import React, { Component } from "react";
import SalaryChangeForm from "../SalaryChangeForm/SalaryChangeForms";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SalaryChangeForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente SalaryChange
================================================================================ */
class SalaryChangePage extends Component {
    render() {
        return (
            <div>

                <SalaryChangeForm />

            </div>
        )
    }
}

export default SalaryChangePage;